var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.76 17.75H10.23C9.13001 17.75 8.26 17.21 7.77001 16.23L6.88001 14.44C6.67001 14.01 6.24001 13.75 5.76001 13.75H1.99001C1.58001 13.75 1.24001 13.41 1.24001 13C1.24001 12.59 1.59001 12.25 2.00001 12.25H5.76001C6.81001 12.25 7.75001 12.83 8.22001 13.77L9.11001 15.56C9.34 16.02 9.71 16.25 10.23 16.25H13.76C14.24 16.25 14.67 15.99 14.88 15.56L15.77 13.77C16.24 12.83 17.18 12.25 18.23 12.25H21.97C22.38 12.25 22.72 12.59 22.72 13C22.72 13.41 22.38 13.75 21.97 13.75H18.23C17.75 13.75 17.32 14.01 17.11 14.44L16.22 16.23C15.75 17.17 14.81 17.75 13.76 17.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.67 7.75H10.34C9.92 7.75 9.58 7.41 9.58 7C9.58 6.59 9.92 6.25 10.33 6.25H13.66C14.07 6.25 14.41 6.59 14.41 7C14.41 7.41 14.08 7.75 13.67 7.75Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10.75H9.5C9.09 10.75 8.75 10.41 8.75 10C8.75 9.59 9.09 9.25 9.5 9.25H14.5C14.91 9.25 15.25 9.59 15.25 10C15.25 10.41 14.91 10.75 14.5 10.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon13);
export default __webpack_public_path__ + "static/media/icon-13.297079f12de37dc53367cb8ec9b38680.svg";
export { ForwardRef as ReactComponent };